/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UnproxiedMcpServerClientUsageRow,
  UnproxiedMcpServerClientUsageRow$inboundSchema,
} from "./unproxiedmcpserverclientusagerow.js";

/**
 * Result of a Shadow-MCP-backed per-client usage lookup for an unproxied MCP server
 */
export type GetUnproxiedMcpServerClientUsageResult = {
  clients: Array<UnproxiedMcpServerClientUsageRow>;
  /**
   * Cursor for next page
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const GetUnproxiedMcpServerClientUsageResult$inboundSchema:
  z.ZodMiniType<GetUnproxiedMcpServerClientUsageResult, unknown> = z.pipe(
    z.object({
      clients: z.array(UnproxiedMcpServerClientUsageRow$inboundSchema),
      next_cursor: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        "next_cursor": "nextCursor",
      });
    }),
  );

export function getUnproxiedMcpServerClientUsageResultFromJSON(
  jsonString: string,
): SafeParseResult<GetUnproxiedMcpServerClientUsageResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetUnproxiedMcpServerClientUsageResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetUnproxiedMcpServerClientUsageResult' from JSON`,
  );
}
